import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { ANALYTICS_ACTION_TYPES, ANALYTICS_ITEM_TYPES } from '@fttb/common';
import { selectCommonAnalyticsData } from "../../../../analytics/selectors";
import { getAnalyticsEventType } from "../../../selectors";
import { getAddressCheckModuleData } from "../../../../selectors";
import { ADDRESS_BLOCK_VIEW_STATUSES, GOAL_FTTB_AND_FMC } from "../../constants";
import { SCREENS_ACTIONS } from "../../analytics/constants";
import { selectCurrentViewTexts } from "../../selectors";
import { sendParamsWithBlockName, sendYmReachGoal } from "../../analytics";
import { getSelectedAddress, selectFiasAddress } from "../../moduleSelectors";
export var handleRenderBlockWithAvailableStatuses = function handleRenderBlockWithAvailableStatuses() {
  return function (_, getState) {
    var state = getState();
    var commonAnalyticData = selectCommonAnalyticsData(state);
    var pageType = getAnalyticsEventType(state);
    var field_text = selectFiasAddress(state);
    var _selectCurrentViewTex = selectCurrentViewTexts(state),
      title = _selectCurrentViewTex.title;
    var address_check = getAddressCheckModuleData(state).status;
    var selectedAddress = getSelectedAddress(state);
    var reachGoalParams = {
      address: selectedAddress === null || selectedAddress === void 0 ? void 0 : selectedAddress.value,
      town: (selectedAddress === null || selectedAddress === void 0 ? void 0 : selectedAddress.city) || (selectedAddress === null || selectedAddress === void 0 ? void 0 : selectedAddress.settlement_with_type),
      street: selectedAddress === null || selectedAddress === void 0 ? void 0 : selectedAddress.street_with_type,
      house: "".concat(selectedAddress === null || selectedAddress === void 0 ? void 0 : selectedAddress.house).concat((selectedAddress === null || selectedAddress === void 0 ? void 0 : selectedAddress.block_type) || '').concat((selectedAddress === null || selectedAddress === void 0 ? void 0 : selectedAddress.block) || ''),
      flat: String(selectedAddress === null || selectedAddress === void 0 ? void 0 : selectedAddress.flat)
    };
    var action_id = SCREENS_ACTIONS[address_check];
    if (address_check === ADDRESS_BLOCK_VIEW_STATUSES.checkAddress) return;
    if (address_check === ADDRESS_BLOCK_VIEW_STATUSES.isNotAvailable) {
      sendYmReachGoal(GOAL_FTTB_AND_FMC.FttbAddressConnectionIsNotPossibleNotInME, reachGoalParams);
    }
    sendParamsWithBlockName(pageType, _objectSpread(_objectSpread({}, commonAnalyticData), {}, {
      action: ANALYTICS_ACTION_TYPES.view,
      item_type: ANALYTICS_ITEM_TYPES.block,
      block_title: title,
      field_text: field_text,
      address_check: address_check,
      action_id: action_id
    }));
  };
};